import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-exchange-payout',
  templateUrl: './exchange-payout.component.html',
  styleUrls: ['./exchange-payout.component.css']
})
export class ExchangePayoutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
